export default Object.freeze({
  schema: "new-yokosuka-native-room-actors-v1",
  modelCodes: Object.freeze(["NAT_L"]),
  worlds: Object.freeze({
    durn: Object.freeze([
      Object.freeze({
        actorCode: "NAMS",
        instanceId: "NAMS:durn",
        label: "Lapis Fortune Teller",
        modelCode: "NAT_L",
        position: Object.freeze([2.0999999046325684, 0, -3.4000000953674316]),
        rotationDegrees: Object.freeze([0, 180, 0]),
        evidence: Object.freeze({
          source: "extracted_files/data/SCENE/01/DURN/MAPINFO.BIN",
          mapinfoSha256: "d38ba150dca8fc6af4bb97656b1745e4bc3d90dbc8817cc5c78fcc306cd830d5",
          positionOperation: "0x0018 at 0x24d3c",
          rotationOperation: "0x001d at 0x24d68",
          motionOperation: "0x0028 at 0x24d90",
          visibilityOperation: "0x001f at 0x24da4",
        }),
      }),
    ]),
  }),
});
